// extracted by mini-css-extract-plugin
export default {"percent":"Students_percent__RNYM9","gap":"Students_gap__fRmTz"};